import { NodeEdgeMapper } from '@iotv/datamodel-core';
import ApiGateway from '../../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
export const getDeviceContext = async (params) => {
    const res = { err: null, data: null };
    const apiRes = (await ApiGateway.post('/device/getContext', params, 'ConsumerApi'));
    debug && console.log('getDeviceContext apiRes', apiRes);
    if (apiRes.data)
        res.data = { nodeEdgeMapper: new NodeEdgeMapper(apiRes.data.nodeEdgeMapper) };
    else
        res.err = apiRes.err;
    return res;
};
